export default __webpack_public_path__ + "static/media/SED.1cf22b77.png";